import { APP_HOSTNAME, PBF_UAT_HOSTNAME, PBF_HOSTNAME, POLICY_INSPECTION_HOSTNAME } from '@/common/utils/variables.js'

export const PLANBOOK_PAGE_MAP = {
  login: `${APP_HOSTNAME}/user/login`,

  planbookInputFamilyv4: `${PBF_UAT_HOSTNAME}/planBook/planbookInput/pages/family/indexv4/indexv4.html`,
  planbookInputCompare3: `${PBF_UAT_HOSTNAME}/planBook/planbookInput/pages/compare3/index.html`,

  planbookResult: `${PBF_UAT_HOSTNAME}/planBook/planBookResult/pages/planbkTemplate.html`,
  planbookResult2: `${PBF_UAT_HOSTNAME}/planBook/planBookResult/pages/planbkTemplatev2.html`,

  feedback: `${PBF_UAT_HOSTNAME}/planBook/projectGroup/feedback/index.html`,
  deepseekReport: `${PBF_UAT_HOSTNAME}/planBook/projectGroup/deepseek/report.html`,

  planbookInnovative: `${PBF_HOSTNAME}/planbook-innovative/`,

  dataCollection: `${PBF_HOSTNAME}/planBook/planbookAccessories/data-collection/index.html`,
  pdfViewer: `${PBF_HOSTNAME}/planBook/planbookAccessories/pdf-viewer/index.html`,
  familyRiskResult: `${PBF_HOSTNAME}/planBook/planbookAccessories/family-risk/result.html`,
  productsRecommended: `${PBF_HOSTNAME}/planBook/planbookAccessories/products-recommended.html`,

  terms: `${PBF_HOSTNAME}/planBook/termsSearch/pages/terms.html`,
  termsIndex: `${PBF_HOSTNAME}/planBook/termsSearch/pages/index.html`,

  policyInspectionFamilyPolicy: `${POLICY_INSPECTION_HOSTNAME}/annualSurvey/family-policy.html`,
}